import { render, staticRenderFns } from "./VFormField.vue?vue&type=template&id=1386b3f8&"
import script from "./VFormField.vue?vue&type=script&lang=js&"
export * from "./VFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports